import React from 'react';
import { Typography } from 'material-ui';
import styles from './LandingHeader.css';
import SearchFormLandscape from '../../components/SearchContent/SearchFormLandscape';
import { getUserInformation } from '../../components/Login/loginService';
import { getAccountName } from '../../components/Utils/UserFunctions';

/**
 * Landing custom header
 * 
 * @author Luciano Bustos
 */
class LandingHeader extends React.Component {
    constructor(props) {
        super(props);
        this.acccountName = getAccountName();
        this.state = {
            loading: true
        };
        this.currentUser = getUserInformation();
    }
    componentDidMount() {
        this._ismounted = true;
        let url = '';
        if (this.props.parameters && this.props.parameters.image) {
            url = this.props.parameters.image.url;
            this.modifyBG(url);
        }
         
    }

    componentDidUpdate() {
        let url = '';
        if (this.props.parameters && this.props.parameters.image) {
            url = this.props.parameters.image.url;
            this.modifyBG(url);
        }
    }

    modifyBG = (url) => {
        var elem = document.querySelector('.cmsTopContainer');
        this.previousImage = elem.style.backgroundImage;
        elem.classList.add('cmsLandingImage');
        elem.style.backgroundImage = 'url("' + url + '")';
    }

    componentWillUnmount() {
        this._ismounted = false;
        var elem = document.querySelector('.cmsTopContainer');
        elem.classList.remove('cmsLandingImage');
        elem.style.backgroundImage = this.acccountName === 'b2bwebdawson' ? 'url("/assets/header_bg.png")' : 'url("/assets/header_oly_bg.png")';
    }
    render() {
        const { parameters } = this.props;
        return (parameters ?
            <div className="cmsLandingHeader">
                <Typography variant="display2" dangerouslySetInnerHTML={{ __html: parameters.content.image_text }}></Typography>
                {parameters.searcher ?
                    <SearchFormLandscape user={this.currentUser} searchFormType={'H'}/> : ''}
            </div >
            : ''
        );
    }
}

export default (LandingHeader);


// WEBPACK FOOTER //
// ./src/cms/headers/LandingHeader.js